import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      theme="light"
      richColors
      closeButton
      position="bottom-right"
    />
  );
}
